interface LoginCallbackUrlOptions {
  explicit?: string;
  fallback: string;
  query?: string | null;
}

interface CredentialLoginContinuation {
  callbackUrl?: string;
  close: () => void;
  navigate: (callbackUrl: string) => void;
  onSuccess?: () => void;
}

export function resolveLoginCallbackUrl({
  explicit,
  fallback,
  query,
}: LoginCallbackUrlOptions) {
  return explicit ?? query ?? fallback;
}

export function completeCredentialLogin({
  callbackUrl,
  close,
  navigate,
  onSuccess,
}: CredentialLoginContinuation) {
  if (onSuccess) {
    onSuccess();
    close();
    return;
  }

  close();
  if (callbackUrl) navigate(callbackUrl);
}
